import { FC, ReactElement } from 'react';

import { Button } from '../../../../compositions';
import { CouponCodeFormData } from '../../../../entities/@forms/CouponCodeForm/CouponCodeForm';
import { OrderInterface } from '../../../../entities/@shop/Order/Order';
import { useTrans } from '../../../../hooks';
import { CartItemForm } from '../../../@forms/CartItemForm/CartItemForm';
import { Pricing } from '../Pricing/Pricing';

import './CartSection.scss';

interface CartSectionProps extends OrderInterface {
    isLoading: boolean;
    showPayButton: boolean;
    disablePayButton?: boolean;
    onSetCouponCode: (data: CouponCodeFormData) => void;
    onRemoveCouponCode: () => void;
    onSubmitPayment: () => void;
    className?: string;
}

export const CartSection: FC<CartSectionProps> = ({
    isLoading,
    showPayButton,
    disablePayButton,
    items,
    subTotalPrice,
    handlingPrice,
    totalPrice,
    discounts,
    onSetCouponCode,
    onRemoveCouponCode,
    onSubmitPayment,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    return (
        <div className={`cart-section ${className}`}>
            <h2 className="cart-section__heading">
                {trans('containers.checkout.cartSection.yourOrder')}
            </h2>

            <div className="cart-section__products-wrapper">
                {items.map(item => (
                    <CartItemForm
                        key={item.id}
                        {...item}
                        showBigRemoveButton
                        isLoading={isLoading}
                    />
                ))}
            </div>

            <Pricing
                hideCouponCodeInput
                isLoading={isLoading}
                subTotalPrice={subTotalPrice}
                handlingPrice={handlingPrice}
                totalPrice={totalPrice}
                discounts={discounts}
                onSetCouponCode={onSetCouponCode}
                onRemoveCouponCode={onRemoveCouponCode}
                className="cart-section__prices-wrapper"
            />

            {showPayButton && (
                <Button
                    isSmall
                    hasAnimation
                    disabled={isLoading || disablePayButton}
                    text={trans('containers.checkout.cartSection.pay')}
                    onClick={onSubmitPayment}
                    className="cart-section__purchase-button"
                />
            )}
        </div>
    );
};
